import { defineStore } from 'pinia';
import { type Advert } from '~/interfaces/advert-studio';
import { fetchApi, BASE_METHOD } from '~/common/API/baseApi';

interface AdvertModuleState {
  current: {
    id: number | null;
  };
  adverts: Advert[];
  ordersCount: number;
  activeOrdersCount: number;
  unreadMessagesCount: number;
}

export const useAdvertStore = defineStore('advert', {
  state: (): AdvertModuleState => ({
    current: {
      id: null,
    },
    adverts: [],
    ordersCount: 0,
    activeOrdersCount: 0,
    unreadMessagesCount: 0,
  }),
  actions: {
    setAdverts(value: Advert[]) {
      this.adverts = value;
    },
    setCurrentAdvertId(value: number | null) {
      this.current.id = value;
    },
    async fetchSummary() {
      try {
        const res = await fetchApi<{
          ordersCount: number;
          activeOrdersCount: number;
          unreadMessagesCount: number;
        }>({
          endpoint: '/advert/summary',
          method: BASE_METHOD.GET,
          isFullScreenLoading: false,
        });
        this.ordersCount = (res as any)?.ordersCount ?? 0;
        this.activeOrdersCount = (res as any)?.activeOrdersCount ?? 0;
        this.unreadMessagesCount = (res as any)?.unreadMessagesCount ?? 0;
      } catch {
        // silent
      }
    },
  },
});
